import React from 'react'
import { normalizedWarrantName } from '@finance-lab/utils/shared'
import { WarrantListItem } from '@finance-lab/utils/types'

type WarrantEntityWithNames = Pick<WarrantListItem, 'instrumentName' | 'companyName' | 'name' | 'instrumentSymbol'>

function WarrantName({ warrant }: { warrant: WarrantEntityWithNames }) {
    return <>{normalizedWarrantName(warrant)}</>
}

export { WarrantName }
